import React from "react";
import styled from "styled-components";
// import { fonts } from "theme/fonts";

export const Hero = ({
  heroContent = false,
  heroPadding = "56.25%",
  videoStyle,
}) => {
  return (
    heroContent && (
      <HeroWrapper id="hero">
        <HeroContainer heroPadding={heroPadding}>
          <HeroContent style={videoStyle}>{heroContent}</HeroContent>
        </HeroContainer>
      </HeroWrapper>
    )
  );
};

const HeroWrapper = styled.div`
  background: #1e1e1e;
  display: flex;
  flex: 1;
`;

const HeroContainer = styled.div`
  padding-top: ${(props) => (props.heroPadding ? props.heroPadding : 0)};
  position: relative;
  width: 100%;
  display: flex;
`;

const HeroContent = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
  }

  .vimeo {
    width: 100%;
  }
`;
